/**
 * @file use-dialog.js
 * @description Hook para usar o contexto de dialog (CRA)
 */

import { useContext } from "react"
import { DialogContext } from "../contexts/dialog-context.js"

/**
 * Hook para usar o contexto de dialog
 * @returns {Object} Objeto com o contexto de dialog
 */
export function useDialog() {
  const context = useContext(DialogContext)
  if (!context) {
    throw new Error("useDialog must be used within a DialogProvider")
  }
  return context
}
